import React from 'react';
import { IonButton } from '@ionic/react';
import { format, subDays } from 'date-fns';

const METRICS_ICON_URL = 'https://storage.googleapis.com/rev-public/icons/Metrics.svg';

interface MetricsWidgetProps {
  activeUsers: number;
  totalUsers: number;
  totalCoursesCompleted: number;
}

export const MetricsWidget: React.FC<MetricsWidgetProps> = ({ activeUsers, totalUsers, totalCoursesCompleted }) => {
  // Calculate date range for last 30 days
  const today = new Date();
  const thirtyDaysAgo = subDays(today, 30);
  const dateRange = `${format(thirtyDaysAgo, 'MMM d')} - ${format(today, 'MMM d')}`;

  return (
    <div className="bg-white flex w-full sm:min-w-60 flex-col px-5 py-4 rounded-[10px]">
      {/* Row 1: Icon, Title, and Date */}
      <div className="flex w-full items-center">
        <div className="flex items-center gap-3">
          <img
            src={METRICS_ICON_URL}
            alt="Metrics"
            className="w-8 h-8"
          />
          <div className="text-[#2D2D2D] text-base font-medium">
            Metrics
          </div>
          {totalUsers > 0 && (
            <div className="text-[#928881] text-xs font-normal">
              {dateRange}
            </div>
          )}
        </div>
      </div>

      {/* Row 3: Active Users / Total Users */}
      <div className="flex w-full items-center mt-3">
        <div className="text-[#928881] text-base font-normal">
          {activeUsers}/{totalUsers} Active
        </div>
      </div>

      {/* Row 4: Total Courses Completed */}
      <div className="flex w-full items-center mt-2">
        <div className="text-[#928881] text-base font-normal">
          {totalCoursesCompleted} Courses Completed
        </div>
      </div>
    </div>
  );
};
